import { Card, CardBody } from "reactstrap";
import { FormattedMessage } from "react-intl";

const StudentMatching = (props) => {
  var pairKey = [];
  var studentAnswer = [];
  var correctAnswer = [];

  props.data.correctAnswer.split("[,]").forEach((element) => {
    pairKey.push(element.split("[.]")[0]);
    correctAnswer.push(element.split("[.]")[1]);
  });

  props.data.studentAnswer.split("[,]").forEach((element) => {
    studentAnswer.push(element.split("[.]")[1]);
  });

  return (
    <Card className="h-100 mb-0">
      <CardBody>
        <div className="d-table w-100">
          <div className="d-table-row">
            <div className="answer-item"></div>
            <div className="fw-bold answer-item">
              <FormattedMessage id="CorrectAnswer" />
            </div>
            <div className="fw-bold answer-item">
              <FormattedMessage id="StudentsAnswer" />
            </div>
          </div>

          {pairKey.map((answer, index) => (
            <div key={index} className="d-table-row">
              <div className="answer-item ps-3 pe-4">{answer}</div>
              <div className="answer-item pe-4">{correctAnswer[index]}</div>
              <div className="answer-item">{studentAnswer[index]}</div>
            </div>
          ))}
        </div>
      </CardBody>
    </Card>
  );
};

export default StudentMatching;
